import PriceIndicator from '@cbgms/components/src/order-list/price/PriceIndicator'
import { Box, Stack } from '@mui/material'
import { IProductWithState, ProductIDType } from '@cbgms/api'
import { NumericInput } from '@carsys/form/src/NumericInput'

interface IProps extends Omit<React.ComponentProps<typeof NumericInput>, 'children' | 'variant' | 'size'> {
  product: IProductWithState | null
}

export const QuantityWithPrices: React.FC<IProps> = props => {
  const { product, name, label, helperText, required, ...textFieldProps } = props

  return (
    <Stack direction='row' spacing={1}>
      <NumericInput fullWidth={false} name={name} label={label} helperText={helperText} required={required} {...textFieldProps} />
      {product && product.IDType !== ProductIDType.AxNl && (
        <Box display='inline-block'>
          <PriceIndicator product={product} />
        </Box>
      )}
    </Stack>
  )
}
